var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{},[_c('b-tabs',{attrs:{"lazy":"","fill":"","Justified":""},on:{"activate-tab":_vm.changeTab}},[_c('b-tab',{attrs:{"title":"Công việc Sale"}},[_c('sale')],1),_c('b-tab',{attrs:{"title":"Công việc AFS"}},[_c('afs')],1),_c('b-tab',{attrs:{"title":"Công việc CSKH","active":_vm.activeTab}},[_c('cskh')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }